import { Link, type LinkProps } from 'react-router-dom';
import type { IconComponent } from '../icons';
import { classes, type ButtonSize, type ButtonVariant } from './Button';

export interface LinkButtonProps extends LinkProps {
  variant?: ButtonVariant | undefined;
  size?: ButtonSize | undefined;
  icon?: IconComponent | undefined;
  iconRight?: IconComponent | undefined;
  full?: boolean | undefined;
}

/**
 * A router link styled as a button. Its own module so `Button` does not pull
 * react-router into pages without a router (kamera.html, dela.html).
 */
export function LinkButton({ variant = 'secondary', size = 'm', icon: Icon, iconRight: IconRight, full, className, children, ...rest }: LinkButtonProps) {
  return (
    <Link className={classes(variant, size, full, className, !children)} {...rest}>
      {Icon ? <Icon size={18} /> : null}
      {children ? <span className="btn-label">{children}</span> : null}
      {IconRight ? <IconRight size={18} /> : null}
    </Link>
  );
}
